/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Base from './base'
import Keyword from './mixins/_keyword'
import Responds from './mixins/_responds'
import Images from './mixins/_images'
import URI from 'urijs'

import { cleanString } from '../util'

const FLOATING_POINT_REGEX = /^-?\d{0,3}(\.\d{1,2})?$/

/**
 * MCP Option
 *
 * @include Images
 * @include Responds
 * @include Keyword
 *
 * @namespace Model
 */
export default class MCPOption extends Base {
  get modelProperties () {
    return [
      'id',
      'value',
      'keyword',
      'correct_response',
      'points',
      'alt_text'
    ]
  }

  initialize (options) {
    if (options == null) { options = {} }
    super.initialize(...arguments)

    this.include(Responds)
    this.include(Keyword)

    this.initKeyword()

    if (options.uploader) {
      this.uploader = options.uploader
      this.uploadId = options.uploadId
    }

    return this.include(Images)
  }

  validate (attrs, options) {
    const keywordErrors = this.validateKeyword({
      allowBlank: true,
      sessionKeyword: (this.collection != null ? this.collection.poll.get('simple_keywords') : undefined)
    })
    if (keywordErrors !== undefined) {
      return keywordErrors
    }
    // validate points value
    if (attrs.points && !FLOATING_POINT_REGEX.test(attrs.points)) {
      return 'Invalid points'
    }
  }

  hasValue () {
    return this.has('value') && (this.get('value').trim().length > 0)
  }

  /*
   * make sure to clean up events
   * bound to child poll object
   */
  cleanUp () {
    __guard__(this.collection != null ? this.collection.poll : undefined, x => x.off())
    if (this.mcpOptions != null) {
      this.mcpOptions.off()
    }

    return super.cleanUp(...arguments)
  }

  displayValue () {
    if (this.isLatex()) {
      return this.latexEquation()
    } else if (this.isImage()) {
      return this.imageUrl()
    } else {
      return cleanString(this.get('value'))
    }
  }

  // Returns this option's votes as a percentage of the option with the most votes.
  percentageOfMax () {
    let maxResult
    const resultsCount = this.get('results_count')

    // this option have already been removed from a collection
    if (!resultsCount || (this.collection == null)) {
      return 0
    } else if (__guard__(this.collection != null ? this.collection.poll : undefined, x => x.type()) === 'ranking_poll') {
      maxResult = this.collection.length
      return ((maxResult - resultsCount) / (maxResult - 1)) * 100
    } else {
      maxResult = this.collection.highestResult()
      return (resultsCount / maxResult) * 100
    }
  }

  /*
   * Returns this options votes as a percentage of the difference between the
   * option with the fewest votes and the option with the most votes.
   */
  percentageOfMinMaxDifference () {
    let resultsCount
    if (!this.collection) { return }

    const diff = this.collection.highestResult() - this.collection.lowestResult()

    if (!diff) { return } // Return undefined rather than divide by zero error.
    if (!(resultsCount = this.get('results_count'))) { return }

    const result = ((resultsCount - this.collection.lowestResult()) / diff) * 100

    if (__guard__(this.collection != null ? this.collection.poll : undefined, x => x.type()) === 'ranking_poll') {
      return 100 - result // Invert the answer
    } else {
      return result
    }
  }

  ordinalRank () {
    return (this.collection != null ? this.collection.ordinalRank(this) : undefined)
  }

  // This option's votes as a percentage of all votes on this poll.
  percentageOfTotal () {
    return (this.get('results_count') / (this.collection != null ? this.collection.poll.get('results_count') : undefined)) * 100
  }

  toJSON () {
    return this.pick(this.modelProperties)
  }

  isCorrect () {
    /*
     * correct_response is the write attribute so that should
     * take precedence
     */
    if (this.has('correct_response')) {
      return this.get('correct_response')
    } else {
      return this.get('correct')
    }
  }

  responseUrl () {
    const permalink = this.collection.poll.get('permalink')
    return URI('/')
      .segment(this.collection.poll.type() + 's')
      .segment(permalink)
      .segment('options')
      .segment(this.id.toString())
      .segment('results.json')
      .toString()
  }
}

function __guard__ (value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}
